import React, { useEffect, useContext, useState } from 'react';
import { Header } from "../header/Header";
import { VerticalMenu } from '../../containers/verticalMenu/VerticalMenu';
import "./sass/modulo.css";
import { DashBoard } from '../dashBoard/DashBoard';
import { Context } from '../../containers/context/Context';
import { useServicios } from '../../../hooks/useServicios';
import { useLoader } from '../../../hooks/useLoader';
import { TexTranslateDefault } from '../../../translations/FlattenMessages';
import { useIntl } from 'react-intl';
import { Profile } from '../profile/Profile';
import { AppName } from '../appName/AppName';

export const Modulo = ({name, ...rest}) => {

    const [typeMenu, setTypeMenu] = useState(null);

    const { app, dataServicios, setDataServicios } = useContext(Context);

    const { consultarServiciosAdministrador } = useServicios({app});

    const intl = useIntl();

    const txtLoad = TexTranslateDefault(intl, "general.Loading...");

    const {showLoader, hideLoader} = useLoader({"textLoader" : txtLoad});
   
    const onClickVert = (menu) => {
        setTypeMenu(menu);
    }

    const menuComp ={
        "dashBoard" : "menuDashboard",
        "profile" : "menuPerfil",
    };

    const getContent = (nameContent) => {

        const moduleContent = (comp) => {
            return (
                <div className="content_module">
                    {comp}
                </div>
            );
        }

        switch (nameContent) {
            case "dashBoard":
            return (
                    <DashBoard { ...rest } menu={typeMenu !== null ? typeMenu : menuComp[name]} />
                );
            case "profile":
            return (
                moduleContent(<Profile verticalMenu={true} { ...rest } />)
            );
                
            default:
                break;
        }

    }

    const renderContent = getContent(name);

    useEffect(() => {
        if(dataServicios === null){
            showLoader();
            setDataServicios("process");
            consultarServiciosAdministrador({"setData" : setDataServicios});            
        }else if(dataServicios !== null && dataServicios !== "process") {
            hideLoader();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <> {dataServicios !== null && dataServicios !== "process" && 
            <div className="moduloContainer">
                <div className="content-vertical-men">
                    <VerticalMenu typeMenu={typeMenu !== null ? typeMenu : menuComp[name]} onClickVert={onClickVert} />
                    <div className="home_content overflow-y">
                        <Header />
                        {renderContent}
                    </div>
                </div>
            </div>
        }
        { name === 'dashBoard' &&
            <AppName />
        }
         </>
    );
} 